// Englisches Wörterbuch — `Dict` erzwingt Vollständigkeit.
import type { Dict } from "./de";

export const en: Dict = {
  meta: {
    title: "Pulpo: The digital menu for your restaurant",
    description:
      "Guests scan the QR code at the table and see your menu on their phone: in their language, with photos and current prices.",
  },
  nav: { login: "Sign in" },
  hero: {
    eyebrow: "The digital menu for your restaurant",
    title: "Your menu. Every language. Always up to date.",
    sub: "Guests scan the QR code at the table and see your menu on their phone: in their language, with photos and current prices. You manage everything in one place.",
    ctaStart: "Start for free",
    ctaDemo: "See a sample menu",
  },
  steps: {
    title: "How it works",
    items: [
      {
        title: "Sign up and add your dishes",
        body: "Categories, prices, photos. Right in the browser, nothing to install.",
      },
      {
        title: "Put the QR code on the table",
        body: "Print the code, done. Your guests don't need an app.",
      },
      {
        title: "Change things when they change",
        body: "New price, new dish of the day: online in seconds, no reprinting.",
      },
    ],
  },
  included: {
    title: "Everything included",
    hint: "What your menu can do, at no extra cost.",
    price: "included",
    items: [
      {
        name: "Menu in multiple languages",
        note: "with automatic translation for guests from anywhere",
      },
      {
        name: "Photos, allergens and labels",
        note: "every dish with a picture and clean declarations",
      },
      {
        name: "Change prices in seconds",
        note: "no print shop, no stickers",
      },
      {
        name: "Printable QR code",
        note: "for the table, the door or a flyer",
      },
      {
        name: "Your own website and domain",
        note: "your menu lives under your name",
      },
      {
        name: "No app for guests",
        note: "scan, read, order as usual",
      },
    ],
  },
  pricing: {
    title: "The bill, please",
    hint: "The digital menu is free.",
    lines: [
      { name: "Digital menu", price: "€0" },
      { name: "Standard website with menu and contact", price: "€0" },
      { name: "Connect your own domain", price: "€0" },
      { name: "Ads", price: "none" },
    ],
    totalLabel: "Total per month",
    total: "€0",
    note: "Create your restaurant and your menu is online. Thank you for your visit!",
    extrasTitle: "Add if you like",
    extras: [
      { name: "Support via chat and email", price: "€9 / month" },
      { name: "Custom website, designed by us", price: "one-time, from €490" },
    ],
  },
  finale: {
    title: "Online by tonight?",
    sub: "Create your restaurant, add your dishes, and your menu is instantly available at your own address.",
    cta: "Start for free",
  },
  phone: {
    restaurant: "Casa Pulpo",
    menuTitle: "Menu",
    category: "Today's picks",
    dishes: [
      { name: "Soup of the day", price: "€6.50" },
      { name: "Grilled octopus", price: "€18.90" },
      { name: "Chocolate cake", price: "€7.20" },
    ],
  },
};
